import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-safe-place-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './safe-place-icon.component.html',
  styleUrls: ['./safe-place-icon.component.scss'],
})
export class SafePlaceIconComponent {
  @Input() color!: string;
}
